import React, { Component } from 'react';
import { NavLink, Redirect, Route, withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import withBreadcrumbs from 'react-router-breadcrumbs-hoc';
import axios from 'axios';

import './custom.css';
import PersonSelector from './PersonSelector';
import { IntlConsumer } from '../../IntlContext';
import TermsModal from '../../components/TermsGate/TermsModal';
import { getAcceptedTermsVersion, isCurrentTermsAccepted } from '../../api/terms';

// components
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';

// views/Admin
import AnnouncementsAdmin from '../../views/Admin/Announcements/Announcements';
import CourseBasicHR from '../../views/Admin/CourseBasicHR/CourseBasicHR';
import AddCourse from '../../views/Admin/CreateCourse/AddCourse';
import ActivateCourse from '../../views/Admin/CreateCourse/ActivateCourse';
import CreateCourseBasic from '../../views/Admin/CreateCourse/CreateCourseBasic';
import CourseSplit from '../../views/Admin/CourseSplit/CourseSplit';
import CreateCourseImplementation from '../../views/Admin/CreateCourse/CreateCourseImplementation';
import EditCourse from '../../views/Admin/CreateCourse/EditCourse';
import Faculties from '../../views/Admin/CreateCourse/Faculties';
import AddStudyProgram from '../../views/Admin/CreateStudyProgram/AddStudyProgram';
import Details from '../../views/Admin/CreateStudyProgram/Details';
import Implementations from '../../views/Admin/CreateStudyProgram/Implementations';
import Semesters from '../../views/Admin/CreateStudyProgram/Semesters';
import SPDetails from '../../views/Admin/CreateStudyProgram/SPDetails';
import SPImplCourses from '../../views/Admin/CreateStudyProgram/SPImplCourses';
import SPImplemenationsWithoutSPBasic from '../../views/Admin/CreateStudyProgram/SPImplemenationsWithoutSPBasic';
import StudyProgramBasics from '../../views/Admin/CreateStudyProgram/StudyProgramBasics';
import CreateStudyProgramImplementation from '../../views/Admin/CreateStudyProgramImplementation/CreateStudyProgramImplementation';
import CreateExam from '../../views/Admin/Exams/CreateExam';
import FAQAdmin from '../../views/Admin/FAQ/FAQ';
import LockedStudents from '../../views/Admin/LockedStudents';
import SemesterManagement from '../../views/Admin/SemesterManagement/SemesterManagement';
import CourseEnrollmentAdminPanel from '../../views/Admin/Students/CourseEnrollment/CourseEnrollmentAdminPanel';
import StudentFilterCourseEnrollment from '../../views/Admin/Students/CourseEnrollment/StudentFilterCourseEnrollment';
import ExamRegistrationAdminPanel from '../../views/Admin/Students/ExamRegistration/ExamRegistrationAdminPanel';
import StudentFilterExamRegistration from '../../views/Admin/Students/ExamRegistration/StudentFilterExamRegistration';
import InputGradesAdminPanel from '../../views/Admin/Students/InputGrades/InputGradesAdminPanel';
import StudentFilterInputGrades from '../../views/Admin/Students/InputGrades/StudentFilterInputGrades';
import SemesterTransfer from '../../views/Admin/Transfer/SemesterTransfer';
import SemesterTransferSemesters from '../../views/Admin/Transfer/SemesterTransferSemesters';

// views/Assets
import Leases from '../../views/Assets/Leases/Leases';
import Leaseholder from '../../views/Assets/Leaseholder/Leaseholder';
import Premises from '../../views/Assets/Premises';
import Property from '../../views/Assets/Property/Property';
import CreateProperty from '../../views/Assets/Property/CreateProperty';
import PropertyDetails from '../../views/Assets/Property/Details/Details';
import Resources from '../../views/Assets/Resources/Resources';
import Rooms from '../../views/Assets/Rooms/Rooms';
import Vehicles from '../../views/Assets/Vehicles/Vehicles';

// views/CertificateRequest
import SelectStudentsForCertificate from '../../views/CertificateRequest/SelectStudentsForCertificate';

// views/Contact
import Contact from '../../views/Contact/Contact';

// views/Dashboard
import Dashboard from '../../views/Dashboard/';

// views/DegreeDocumentPrint
import DegreePrintWizard from '../../views/DegreeDocumentPrint/Wizard';

// views/DocumentTemplateConfiguration
import TemplateConfig from '../../views/DocumentTemplateConfiguration/TemplateConfig';

// views/EmploymentServiceCS
import StudentFilterEmploymentServiceCS from '../../views/EmploymentServiceCS/StudentFilterEmploymentServiceCS';
import StudentInfoEmploymentServiceCS from '../../views/EmploymentServiceCS/StudentInfoEmploymentServiceCS';

// views/ExternalStudents
import ExternalStudentList from '../../views/ExternalStudents/ExternalStudentList';
import ExternalStudentGradingList from '../../views/ExternalStudents/ExternalStudentGradingList';
import ExternalStudentInputForm from '../../views/ExternalStudents/ExternalStudentForms/ExternalStudentInputForm';
import ExternalStudentProfile from '../../views/ExternalStudents/ExternalStudentProfile/ExternalStudentProfile';
import RegistrationLinkList from '../../views/ExternalStudents/ExternalStudentRegistrationLink/RegistrationLinkList';
import RegistrationLinkStudentList from '../../views/ExternalStudents/ExternalStudentRegistrationLink/RegistrationLinkStudentList';
import OutgoingMobilityStudentList from '../../views/OutgoingMobilityStudents/OutgoingMobilityStudentList';

// views/FAQ
import FAQStudentService from '../../views/FAQ/FAQ';

// views/GenerateUsers
import AccessData from '../../views/GenerateUsers/AccessData';

// views/HR
import CheckPersonAndEmployee from '../../views/HR/add/CheckPersonAndEmployee';
import AddNewEmployee from '../../views/HR/add/AddNewEmployee';
import AddNewPerson from '../../views/HR/add/AddNewPerson';
import EmployeeListAcademic from '../../views/HR/EmployeeListAcademic';
import EmployeeListAssociate from '../../views/HR/EmployeeListAssociate';
import EmployeeListNonAcademic from '../../views/HR/EmployeeListNonAcademic';
import EmploymentList from '../../views/HR/EmploymentList';
import Profile from '../../views/HR/profile/Profile';
import Workload from '../../views/HR/profile/Workload/Workload';
import Reports from '../../views/HR/Reports';
import PositionsForSystematization from '../../views/HR/Systematization/PositionsForSystematization';
import Systematization from '../../views/HR/Systematization/Systematization';

// views/Lookups
import Lookups from '../../views/Lookups/Lookups';

// views/NonCycleStudent
import NonCycleProgramList from '../../views/NonCycleStudent/NonCycleProgram/NonCycleProgramList';
import NonCycleProgramDetails from '../../views/NonCycleStudent/NonCycleProgram/NonCycleProgramDetails';
import NonCycleStudentInputForm from '../../views/NonCycleStudent/NonCycleStudentForms/NonCycleStudentInputForm';
import NonCycleStudentList from '../../views/NonCycleStudent/NonCycleStudentList';
import NonCycleStudentGradingList from '../../views/NonCycleStudent/NonCycleStudentGradingList';
import NonCycleStudentProfile from '../../views/NonCycleStudent/NonCycleStudentProfile/NonCycleStudentProfile';

// views/NotFound
import NotFound from '../../views/NotFound';

// views/Notifications
import Notifications from '../../views/Notifications/Notifications';

// views/OrganizationalUnit
import OrganizationalUnit from '../../views/OrganizationalUnit/OrganizationalUnit';

// views/Poll
import CreateNewPoll from '../../views/Poll/AdminPoll/CreatePoll/CreateNewPoll';
import PollEdit from '../../views/Poll/AdminPoll/PollEdit';
import PollPreviewTabs from '../../views/Poll/AdminPoll/PollPreviewTabs/PollPreviewTabs';
import PollTab from '../../views/Poll/AdminPoll/PollTabs/PollTab';
import CourseListProfessors from '../../views/Poll/ProfessorPoll/CourseList';
import CourseResultsOverview from '../../views/Poll/ProfessorPoll/CourseResultsOverview';
import PollBan from '../../views/Poll/ProfessorPoll/PollBan/PollBan';
import PollBanCourseList from '../../views/Poll/ProfessorPoll/PollBan/PollBanCourseList';
import PollBanStudentList from '../../views/Poll/ProfessorPoll/PollBan/PollBanStudentList';
import PollListProfessors from '../../views/Poll/ProfessorPoll/PollList';
import CourseList from '../../views/Poll/QAPoll/CourseList';
import PollListQA from '../../views/Poll/QAPoll/PollList';
import SspList from '../../views/Poll/QAPoll/SspPoll/SSPList';
import StaffTabs from '../../views/Poll/QAPoll/StaffTabs';
import PollReport from '../../views/Poll/Reports/PollReport';
import SspPollGeneralInformationReport from '../../views/Poll/Reports/SectionReports/SspPollGeneralInformationReport';
import SspPollServicesReport from '../../views/Poll/Reports/SectionReports/SspPollServicesReport';
import SspPollStudyProgramOrganizationReport from '../../views/Poll/Reports/SectionReports/SspPollStudyProgramOrganizationReport';
import SspPollSyllabusReport from '../../views/Poll/Reports/SectionReports/SspPollSyllabusReport';
import StaffPollCourseReport from '../../views/Poll/Reports/SectionReports/StaffPollCourseReport';
import StaffPollStaffReport from '../../views/Poll/Reports/SectionReports/StaffPollStaffReport';
import StaffPollStructureReport from '../../views/Poll/Reports/SectionReports/StaffPollStructureReport';
import CoursePollPreview from '../../views/Poll/StudentPoll/CoursePollPreview';
import PollCourseListPreview from '../../views/Poll/StudentPoll/PollCourseListPreview';
import PollList from '../../views/Poll/StudentPoll/PollList';
import StudentPollPreview from '../../views/Poll/StudentPoll/PollPreview/StudentPollPreview';

// views/Professor
import Courses from '../../views/Professor/Courses/Courses';
import CourseDetails from '../../views/Professor/Courses/CourseDetails';
import CourseStatistics from './../../views/Professor/Courses/CourseStatistics';
import CourseStudents from './../../views/Professor/Courses/CourseStudents';
import FilterStudentsForProfessor from '../../views/Professor/FilterStudentsForProfessor';
import PersonalInfo from '../../views/Professor/PersonalInfo';
import ExamStatistic from '../../views/Professor/ProfessorHistoryGrades/ExamStatistic';
import ProfessorHistoryGrades from '../../views/Professor/ProfessorHistoryGrades/ProfessorHistoryGrades';
import StudentsGrades from './../../views/Professor/ProfessorHistoryGrades/StudentsGrades';
import ActiveExams from '../../views/Professor/ProfessorInputGrades/ActiveExams';
import InputGrades from '../../views/Professor/ProfessorInputGrades/InputGrades';
import StudentInfoAndGrades from './../../views/Professor/ProfessorInputGrades/StudentInfoAndGrades';
import ProfessorUpcomingExams from '../../views/Professor/ProfessorUpcomingExams/ProfessorUpcomingExams';
import StatisticsForProfessor from '../../views/Professor/StatisticsForProfessor/StatisticsForProfessor';

// views/Scholarship
import Scholarship from '../../views/Scholarship/Scholarship';

// views/Statistics
import Router from '../../views/Statistics/Router';

// views/StudentCoursesOverview
import CurrentSemesterCourses from '../../views/StudentCoursesOverview/CurrentSemesterCourses';
import StudentCoursesOverview from '../../views/StudentCoursesOverview/StudentCoursesOverview';

// views/StudentOptionalCourses
import CollisionCourses from '../../views/StudentOptionalCourses/CollisionCourses';
import OptionalCourses from '../../views/StudentOptionalCourses/OptionalCourses';

// views/StudentPassedExams
import StudentPassedExams from '../../views/StudentPassedExams/StudentPassedExams';

// views/StudentPersonalInfo
import StudentPersonalInfo from '../../views/StudentPersonalInfo/PersonalInfo';

// views/StudentRegisterExams
import StudentRegisterExams from '../../views/StudentRegisterExams/StudentRegisterExams';
import StudentRegisteredExams from '../../views/StudentRegisterExams/StudentRegisteredExams';

// views/StudentService
import Certificates from '../../views/StudentService/Certificates/Certificates';
import Collision from '../../views/StudentService/Collision/Collision';
import Configuration from '../../views/StudentService/Configuration/Configurations';
import AddStaff from '../../views/StudentService/CreateCourseImplementation/AddStaff';
import CourseBasics from '../../views/StudentService/CreateCourseImplementation/CourseBasics';
import CourseImplementations from '../../views/StudentService/CreateCourseImplementation/CourseImplementations';
import DocumentRequests from '../../views/StudentService/DocumentRequests/DocumentRequests';
import Employees from '../../views/StudentService/Employees/Employees';
import ExamApplications from '../../views/StudentService/ExamApplications/ExamApplications';
import ExamApplicationsForCurrentExam from '../../views/StudentService/ExamApplications/ExamApplicationsForCurrentExam';
import CandidateDetails from '../../views/StudentService/ExamEquivalence/Candidates/CandidatesDetails/CandidateDetails';
import CandidatesTab from '../../views/StudentService/ExamEquivalence/Candidates/CandidatesTab/CandidatesTab';
import CreateCandidatesTab from '../../views/StudentService/ExamEquivalence/Candidates/CreateCandidates/CreateCandidatesTab';
import CommitteeDetails from '../../views/StudentService/ExamEquivalence/Comitee/CommitteeDetails/CommitteeDetails';
import CommitteePreview from '../../views/StudentService/ExamEquivalence/Comitee/CommitteePreview';
import ExamRecognition from '../../views/StudentService/ExamRecognition/ExamRecognition';
import StudentsTab from '../../views/StudentService/ExamRecognition/StudentsTab';
import CancelGrade from '../../views/StudentService/Exams/CancelGrade';
import CancelGradeAndNewCommitteeExam from '../../views/StudentService/Exams/CancelGradeAndNewCommitteeExam';
import CoursesList from '../../views/StudentService/Exams/CoursesList';
import CreateExams from '../../views/StudentService/Exams/CreateExams';
import EditExam from '../../views/StudentService/Exams/EditExam';
import FilterStudentsForCommitteeExam from '../../views/StudentService/Exams/FilterStudentsForCommitteeExam';
import RegisteredStudents from '../../views/StudentService/Exams/RegisteredStudents';
import EditExamTerm from '../../views/StudentService/ExamTerms/EditExamTerm';
import ExamGroups from '../../views/StudentService/ExamTerms/ExamGroups';
import Exams from '../../views/StudentService/ExamTerms/Exams';
import ExamTerms from '../../views/StudentService/ExamTerms/ExamTerms';
import ExamTermStatistics from '../../views/StudentService/ExamTerms/ExamTermStatistics';
import AllStudents from '../../views/StudentService/FilterStudents/AllStudents';
import FilterStudents from '../../views/StudentService/FilterStudents/FilterStudents';
import Withdrawal from '../../views/StudentService/FilterStudents/Withdrawal';
import WithdrawalForm from '../../views/StudentService/FilterStudents/WithdrawalForm';
import MailForm from '../../views/StudentService/MailForm/MailForm';
import AverageGrade from '../../views/StudentService/Reports/AverageGrade';
import AllReports from '../../views/StudentService/Reports/AllReports';
import ConstReports from '../../views/StudentService/Reports/ConstReports/ConstReports';
import StudentCreate from '../../views/StudentService/StudentCreateAndEdit/StudentCreate';
import StudyPrograms from './../../views/StudentService/StudentEnroll/StudyPrograms';
import NewGroup from '../../views/StudentService/StudentGroups/NewGroup';
import Staff from './../../views/StudentService/StudentGroups/Staff';
import Students from '../../views/StudentService/StudentGroups/Students';
import TypeCourseAndImplementations from '../../views/StudentService/StudentGroups/TypeCourseAndImplementations';
import StudentFilterForSPEnroll from '../../views/StudentService/StudentOverview/StudentFilterForSPEnroll';
import StudentOverview from '../../views/StudentService/StudentOverview/StudentOverview';
import StudentOverviewFilter from '../../views/StudentService/StudentOverview/StudentOverviewFilter';
import StudentSPEnroll from '../../views/StudentService/StudentOverview/StudentSPEnroll';
import StudentsReports from '../../views/StudentService/StudentsReports/StudentsReports';
import PostgraduateSpecialistSP from '../../views/StudentService/StudyPrograms/PostgraduateSpecialistSP/PostgraduateSpecialistSP';
import StudentServiceSPImpl from '../../views/StudentService/StudyPrograms/StudentServiceSPImpl';
import StudentServiceSPImplDetails from '../../views/StudentService/StudyPrograms/StudentServiceSPImplDetails';
import StudentServiceSPImplSemesters from '../../views/StudentService/StudyPrograms/StudentServiceSPImplSemesters';
import StudentServiceStudyPrograms from '../../views/StudentService/StudyPrograms/StudentServiceStudyPrograms';
import CourseEnrollment from '../../views/StudentService/ThirdCycle/CourseEnrollment/CourseEnrollment';
import ThirdCycle from '../../views/StudentService/ThirdCycle/ThirdCycle';
import Users from '../../views/StudentService/User/Users';

// views/StudentsCertificateRequest
import StudentsCertificateRequests from '../../views/StudentsCertificateRequest/StudentsCertificateRequests';
import AdminUsers from '../../views/Admin/AdminUsers/AdminUsers';
import OnlineEnrollment from '../../views/Admin/OnlineEnrollment/OnlineEnrollment';
import CopyStudyProgram from "../../views/Admin/CreateStudyProgramImplementation/CopyStudyProgram";
import CopyStudyProgramCourses from "../../views/Admin/CreateStudyProgramImplementation/CopyStudyProgramCourses";
import Mentorships from '../../views/Professor/Mentorships';

// Note: Configurations import was renamed to avoid conflict
const Configurations = Configuration;
// breadcrumbs can be any type of component or string
// const UserBreadcrumb = ({ match }) =>
//     <span>{match.params.userId}</span>; // use match param userId to fetch/display user name
const Breadcrumbs = ({ breadcrumbs }) => (
    <div style={{ float: 'right' }} className="d-md-down-none" >
        {breadcrumbs.map((breadcrumb, index) => (
            <span key={breadcrumb.props.key} style={{ fontSize: '1.4rem' }}>
                <NavLink to={breadcrumb.props.match.url}>
                    {breadcrumb}
                </NavLink>
                {(index < breadcrumbs.length - 1) && <i> / </i>}
            </span>
        ))}
    </div>
);
const BreadcrumbsHoc = withBreadcrumbs([
    { path: '/nastavno-i-naučno-istraživačko-osoblje', breadcrumb: 'Nastavno i naučno-istraživačko osoblje' },
    { path: '/', breadcrumb: <FormattedMessage id="route.home" /> }
])(Breadcrumbs);

class Full extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            activeRole: '',
            newNotifications: [],
            termsLoaded: false,
            termsAccepted: false,
        };
    }

    componentDidMount() {
        // Check whether the user has accepted the current Terms and Conditions
        getAcceptedTermsVersion()
            .then(v => this.setState({ termsAccepted: isCurrentTermsAccepted(v), termsLoaded: true }))
            // Backend unreachable / error -> do NOT block the app with the gate;
            // only a successful "not accepted" response should show it.
            .catch(() => this.setState({ termsAccepted: true, termsLoaded: true }));

        axios.get('/user/current')
            .then(response => {
                localStorage.setItem('activeRole', response.data);
                const activeRole = response.data;
                this.setState({ activeRole });

                if (!window.$setLanguageFirstTime) {
                    if ((activeRole.includes('Katolički') || activeRole.includes('Integrirani filozofsko-teološki studij'))) {
                        this.props.switchToCroatian();
                        window.$setLanguageFirstTime = true;
                    } else {
                        this.props.switchToBosnian();
                        window.$setLanguageFirstTime = true;
                    }
                }
            }).catch(error => {
                // TODO amel: error handling
                console.error('Failed to fetch active userrole');
            });
    }

    // componentWillMount() {
    //     this.unlisten = this.props.history.listen((location, action) => {
    //         // on route change
    //         if (localStorage.getItem('activeRole') !== 'AIDA') {
    //             this.fetchNewNotification();
    //         }
    //     });
    // }

    // componentWillUnmount() {
    //     this.unlisten();
    // }

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     console.log('promjenaaa', prevState.activeRole);
    //     console.log('promjenaaa', this.state.activeRole);
    //     console.log('promjenaaa', snapshot);
    //     // if (this.state.activeRole.includes('Katolički') || this.state.activeRole.includes('Integrirani filozofsko-teološki studij')) this.props.switchToCroatian();
    //     if (prevState.activeRole !== this.state.activeRole) {
    //         console.log('promjenaaa', prevState.activeRole);
    //         console.log('promjenaaa', this.state.activeRole);
    //         console.log('promjenaaa', snapshot);
    //         if (this.state.activeRole.includes('Katolički') || this.state.activeRole.includes('Integrirani filozofsko-teološki studij')) this.props.switchToCroatian();
    //     }
    // }


    render() {
        const { activeRole } = this.state;
        return (
            <div className="app">

                <TermsModal
                    open={this.state.termsLoaded && !this.state.termsAccepted}
                    onAccepted={() => this.setState({ termsAccepted: true })}
                    onDecline={() => {
                        window.location.href = `${process.env.REACT_APP_EUNSA_KEYCLOAK_URL}/realms/isss/protocol/openid-connect/logout?redirect_uri=${process.env.REACT_APP_EUNSA_FRONTEND_URL}`;
                    }}
                />

                <Route path="/u/:id" component={PersonSelector} />
                <IntlConsumer>
                    {({ switchToEnglish, switchToBosnian, switchToCroatian }) => (
                        <Header activeRole={this.state.activeRole} loading={this.state.loading} switchToCroatian={switchToCroatian} />
                    )}
                </IntlConsumer>

                <div className="app-body">
                    <Route component={Sidebar} />
                    <main className="main">
                        <div className="container-fluid" style={{ paddingTop: '30px' }}>
                            <div>
                                <BreadcrumbsHoc />
                            </div>


                            {activeRole.substr(0, 13) === 'Administrator' &&
                                <div>
                                    <Route path="/šifrarnici" component={Lookups} />
                                    {/* <Route path="/univerzitet/*" component={OrganizationalUnit} /> */}
                                    <Route path="/organizacione-jedinice" component={OrganizationalUnit} />
                                    <Route path="/štampanje-diploma" component={DegreePrintWizard} />
                                    <Route path="/konfiguracije" component={TemplateConfig} />
                                    <Route path="/statistika" component={Router} />
                                    <Route exact path="/predmeti" component={CreateCourseBasic} />
                                    <Route exact path="/razdvajanje-predmeta" component={CourseSplit} />
                                    <Route exact path="/predmeti/detalji" component={CourseDetails} />
                                    <Route exact path="/hr-predmeti" component={CourseBasicHR}/>
                                    <Route path="/predmeti/kreiranje-predmeta" component={AddCourse} />
                                    <Route path="/predmeti/kreiranje-implementacije" component={CreateCourseImplementation} />
                                    <Route path="/predmeti/izmjena-predmeta" component={EditCourse} />
                                    <Route path="/predmeti/detalji-i-arhiviranje" component={Faculties} />
                                    <Route path="/predmeti/detalji-i-aktiviranje" component={ActivateCourse} />
                                    <Route exact path="/osnovni-studijski-programi" component={StudyProgramBasics} />
                                    <Route path="/osnovni-studijski-programi/kreiranje-smjera" component={AddStudyProgram} />
                                    <Route path="/osnovni-studijski-programi/implementacije/izmjena-i-detalji" component={Details} />
                                    <Route path="/osnovni-studijski-programi/implementacije/kopiranje" component={CopyStudyProgram} />
                                    <Route path="/povezivanje-implementacija-smjera/detalji" component={Details} />
                                    <Route path="/osnovni-studijski-programi/implementacije/semestri" component={Semesters} />
                                    <Route path="/osnovni-studijski-programi/implementacije/predmeti" component={SPImplCourses} />
                                    <Route exact path="/osnovni-studijski-programi/implementacije" component={Implementations} />
                                    <Route path="/osnovni-studijski-programi/izmjena-i-detalji" component={SPDetails} />
                                    <Route path="/kreiranje-implementacije-smjera" component={CreateStudyProgramImplementation} />
                                    <Route exact path="/povezivanje-implementacija-smjera" component={SPImplemenationsWithoutSPBasic} />
                                    <Route path="/diplomirani-studenti" component={LockedStudents} />
                                    <Route exact path="/studenti/unos-ocjena" component={StudentFilterInputGrades} />
                                    <Route exact path="/studenti/unos-ocjena/forma" component={InputGradesAdminPanel} />
                                    <Route exact path="/studenti/upis-na-predmet" component={StudentFilterCourseEnrollment} />
                                    <Route exact path="/studenti/upis-na-predmet/forma" component={CourseEnrollmentAdminPanel} />
                                    <Route exact path="/studenti/prijava-ispita" component={StudentFilterExamRegistration} />
                                    <Route exact path="/studenti/prijava-ispita/forma" component={ExamRegistrationAdminPanel} />
                                    <Route exact path="/kreiranje-ispita" component={CreateExam} />
                                    <Route exact path="/pristupni-podaci" component={AccessData} />

                                    <Route exact path="/ankete" component={PollTab} />
                                    <Route exact path="/ankete/kreiranje" component={CreateNewPoll} />
                                    <Route path="/ankete/detalji" component={PollPreviewTabs} />
                                    <Route path="/ankete/uredi" component={PollEdit} />
                                    <Route exact path="/faq" component={FAQAdmin} />
                                    <Route exact path="/obavjestenja" component={AnnouncementsAdmin}/>

                                    <Route exact path="/nastavno-osoblje" component={Employees} />
                                    <Route path="/nastavno-osoblje/lični-podaci" component={PersonalInfo} />
                                    <Route exact path="/nastavno-osoblje/predmeti" component={Courses} />
                                    <Route exact path="/nastavno-osoblje/mentorstva" component={Mentorships} />
                                    <Route exact path="/nastavno-osoblje/predmeti/detalji" component={CourseDetails} />
                                    <Route exact path="/nastavno-osoblje/predmeti/studenti" component={CourseStudents} />
                                    <Route path="/nastavno-osoblje/predmeti/studenti/detalji" component={StudentInfoAndGrades} />
                                    <Route path="/nastavno-osoblje/predmeti/statistika" component={CourseStatistics} />
                                    <Route exact path="/semestri" component={SemesterManagement} />

                                    <Route exact path="/filtriranje-studenata" component={StudentOverviewFilter} />
                                    <Route path="/filtriranje-studenata/informacije-o-studentu" component={StudentOverview} />

                                    <Route exact path="/prebacivanje-podataka" component={SemesterTransfer} />
                                    <Route exact path="/prebacivanje-podataka/semestri-i-ocjene" component={SemesterTransferSemesters} />
                                    <Route exact path="/predmeti/implementacije" component={CourseImplementations} />
                                    <Route path="/predmeti/implementacije/osoblje" component={AddStaff} />

                                    <Route exact path="/izvještaji" component={() => (<StudentsReports />)} />
                                    <Route exact path="/izvještaji-hr" component={Reports} />

                                    <Route exact path="/dolazne-mobilnosti" component={ExternalStudentList} />
                                    <Route exact path="/dolazne-mobilnosti/student" component={ExternalStudentProfile} />
                                    {/* <Route exact path="/dolazne-mobilnosti/kreiranje" component={ExternalStudentInputForm} /> */}
                                    <Route exact path="/dolazne-mobilnosti/registracijski-linkovi" component={RegistrationLinkList} />
                                    <Route exact path="/dolazne-mobilnosti/registracijski-linkovi/prijavljeni-studenti" component={RegistrationLinkStudentList} />

                                    <Route exact path="/neciklicni-studij" component={NonCycleStudentList}/>
                                    <Route exact path="/neciklicni-studij/student" component={NonCycleStudentProfile}/>
                                    {/* <Route exact path="/neciklicni-studij/kreiranje" component={NonCycleStudentInputForm}/> */}
                                    <Route exact path="/neciklicni-studij/programi" component={NonCycleProgramList}/>
                                    <Route exact path="/neciklicni-studij/programi/detalji" component={NonCycleProgramDetails}/>
                                    <Route exact path="/online-upis" component={OnlineEnrollment}/>

                                    <Route exact path="/administratori" component={AdminUsers}/>
                                </div>
                            }

                            {activeRole === 'AIDA' &&
                            <div>
                                <Route path="/šifrarnici" component={Lookups} />
                                {/* <Route path="/univerzitet/*" component={OrganizationalUnit} /> */}
                                <Route path="/organizacione-jedinice" component={OrganizationalUnit} />
                                <Route path="/štampanje-diploma" component={DegreePrintWizard} />
                                <Route path="/konfiguracije" component={TemplateConfig} />
                                <Route path="/statistika" component={Router} />
                                <Route exact path="/predmeti" component={CreateCourseBasic} />
                                <Route exact path="/predmeti/detalji" component={CourseDetails} />
                                <Route exact path="/hr-predmeti" component={CourseBasicHR}/>
                                <Route path="/predmeti/kreiranje-predmeta" component={AddCourse} />
                                <Route path="/predmeti/kreiranje-implementacije" component={CreateCourseImplementation} />
                                <Route path="/predmeti/izmjena-predmeta" component={EditCourse} />
                                <Route path="/predmeti/detalji-i-arhiviranje" component={Faculties} />
                                <Route path="/predmeti/detalji-i-aktiviranje" component={ActivateCourse} />
                                <Route exact path="/osnovni-studijski-programi" component={StudyProgramBasics} />
                                <Route path="/osnovni-studijski-programi/kreiranje-smjera" component={AddStudyProgram} />
                                <Route path="/osnovni-studijski-programi/implementacije/izmjena-i-detalji" component={Details} />
                                <Route path="/osnovni-studijski-programi/implementacije/kopiranje" component={CopyStudyProgram} />
                                <Route path="/povezivanje-implementacija-smjera/detalji" component={Details} />
                                <Route path="/osnovni-studijski-programi/implementacije/semestri" component={Semesters} />
                                <Route path="/osnovni-studijski-programi/implementacije/predmeti" component={SPImplCourses} />
                                <Route exact path="/osnovni-studijski-programi/implementacije" component={Implementations} />
                                <Route path="/osnovni-studijski-programi/izmjena-i-detalji" component={SPDetails} />
                                <Route path="/kreiranje-implementacije-smjera" component={CreateStudyProgramImplementation} />
                                <Route exact path="/povezivanje-implementacija-smjera" component={SPImplemenationsWithoutSPBasic} />
                                <Route path="/diplomirani-studenti" component={LockedStudents} />
                                <Route exact path="/studenti/unos-ocjena" component={StudentFilterInputGrades} />
                                <Route exact path="/studenti/unos-ocjena/forma" component={InputGradesAdminPanel} />
                                <Route exact path="/studenti/upis-na-predmet" component={StudentFilterCourseEnrollment} />
                                <Route exact path="/studenti/upis-na-predmet/forma" component={CourseEnrollmentAdminPanel} />
                                <Route exact path="/studenti/prijava-ispita" component={StudentFilterExamRegistration} />
                                <Route exact path="/studenti/prijava-ispita/forma" component={ExamRegistrationAdminPanel} />
                                <Route exact path="/kreiranje-ispita" component={CreateExam} />
                                <Route exact path="/predmeti/implementacije" component={CourseImplementations} />
                                <Route path="/predmeti/implementacije/osoblje" component={AddStaff} />

                                <Route exact path="/ankete" component={PollTab} />
                                <Route exact path="/ankete/kreiranje" component={CreateNewPoll} />
                                <Route path="/ankete/detalji" component={PollPreviewTabs} />
                                <Route path="/ankete/uredi" component={PollEdit} />
                                <Route exact path="/faq" component={FAQAdmin} />
                                <Route exact path="/obavjestenja" component={AnnouncementsAdmin}/>

                                <Route exact path="/nastavno-osoblje" component={Employees} />
                                <Route path="/nastavno-osoblje/lični-podaci" component={PersonalInfo} />
                                <Route exact path="/nastavno-osoblje/mentorstva" component={Mentorships} />
                                <Route exact path="/nastavno-osoblje/predmeti" component={Courses} />
                                <Route exact path="/nastavno-osoblje/predmeti/detalji" component={CourseDetails} />
                                <Route exact path="/nastavno-osoblje/predmeti/studenti" component={CourseStudents} />
                                <Route path="/nastavno-osoblje/predmeti/studenti/detalji" component={StudentInfoAndGrades} />
                                <Route path="/nastavno-osoblje/predmeti/statistika" component={CourseStatistics} />
                                <Route exact path="/semestri" component={SemesterManagement} />


                                <Route exact path="/filtriranje-studenata" component={StudentOverviewFilter} />
                                <Route path="/filtriranje-studenata/informacije-o-studentu" component={StudentOverview} />

                                <Route exact path="/izvještaji" component={() => (<StudentsReports />)} />

                                <Route exact path="/prebacivanje-podataka" component={SemesterTransfer} />
                                <Route exact path="/prebacivanje-podataka/semestri-i-ocjene" component={SemesterTransferSemesters} />

                                <Route exact path="/dolazne-mobilnosti" component={ExternalStudentList} />
                                <Route exact path="/unsa-studenti-mobilnost" component={OutgoingMobilityStudentList} />
                                <Route exact path="/dolazne-mobilnosti/student" component={ExternalStudentProfile} />
                                {/* <Route exact path="/dolazne-mobilnosti/kreiranje" component={ExternalStudentInputForm} /> */}
                                <Route exact path="/dolazne-mobilnosti/registracijski-linkovi" component={RegistrationLinkList} />
                                <Route exact path="/dolazne-mobilnosti/registracijski-linkovi/prijavljeni-studenti" component={RegistrationLinkStudentList} />

                                <Route exact path="/neciklicni-studij" component={NonCycleStudentList}/>
                                <Route exact path="/neciklicni-studij/student" component={NonCycleStudentProfile}/>
                                {/* <Route exact path="/neciklicni-studij/kreiranje" component={NonCycleStudentInputForm}/> */}
                                <Route exact path="/neciklicni-studij/programi" component={NonCycleProgramList}/>
                                <Route exact path="/neciklicni-studij/programi/detalji" component={NonCycleProgramDetails}/>

                                <Route exact path="/administratori" component={AdminUsers}/>
                            </div>
                            }

                            {activeRole === 'Support' &&
                            <div>
                                <Route exact path="/predmeti" component={CreateCourseBasic} />
                                <Route exact path="/predmeti/detalji" component={CourseDetails} />
                                <Route path="/predmeti/kreiranje-predmeta" component={AddCourse} />
                                <Route path="/predmeti/kreiranje-implementacije" component={CreateCourseImplementation} />
                                <Route path="/predmeti/izmjena-predmeta" component={EditCourse} />
                                <Route path="/predmeti/detalji-i-arhiviranje" component={Faculties} />
                                <Route exact path="/osnovni-studijski-programi" component={StudyProgramBasics} />
                                <Route path="/osnovni-studijski-programi/kreiranje-smjera" component={AddStudyProgram} />
                                <Route path="/osnovni-studijski-programi/implementacije/izmjena-i-detalji" component={Details} />
                                <Route path="/povezivanje-implementacija-smjera/detalji" component={Details} />
                                <Route path="/osnovni-studijski-programi/implementacije/semestri" component={Semesters} />
                                <Route path="/osnovni-studijski-programi/implementacije/predmeti" component={SPImplCourses} />
                                <Route exact path="/osnovni-studijski-programi/implementacije" component={Implementations} />
                                <Route path="/osnovni-studijski-programi/izmjena-i-detalji" component={SPDetails} />
                                <Route path="/kreiranje-implementacije-smjera" component={CreateStudyProgramImplementation} />
                                <Route exact path="/povezivanje-implementacija-smjera" component={SPImplemenationsWithoutSPBasic} />
                                <Route path="/diplomirani-studenti" component={LockedStudents} />
                                <Route exact path="/studenti/unos-ocjena" component={StudentFilterInputGrades} />
                                <Route exact path="/studenti/unos-ocjena/forma" component={InputGradesAdminPanel} />
                                <Route exact path="/studenti/upis-na-predmet" component={StudentFilterCourseEnrollment} />
                                <Route exact path="/studenti/upis-na-predmet/forma" component={CourseEnrollmentAdminPanel} />
                                <Route exact path="/studenti/prijava-ispita" component={StudentFilterExamRegistration} />
                                <Route exact path="/studenti/prijava-ispita/forma" component={ExamRegistrationAdminPanel} />
                                <Route exact path="/kreiranje-ispita" component={CreateExam} />
                                {/*<Route exact path="/pristupni-podaci" component={AccessData} />*/}

                                <Route exact path="/ankete" component={PollTab} />
                                <Route exact path="/ankete/kreiranje" component={CreateNewPoll} />
                                <Route path="/ankete/detalji" component={PollPreviewTabs} />
                                <Route path="/ankete/uredi" component={PollEdit} />
                                <Route exact path="/faq" component={FAQAdmin} />

                                <Route exact path="/nastavno-osoblje" component={Employees} />
                                <Route path="/nastavno-osoblje/lični-podaci" component={PersonalInfo} />
                                <Route exact path="/nastavno-osoblje/predmeti" component={Courses} />
                                <Route exact path="/nastavno-osoblje/predmeti/detalji" component={CourseDetails} />
                                <Route exact path="/nastavno-osoblje/predmeti/studenti" component={CourseStudents} />
                                <Route path="/nastavno-osoblje/predmeti/studenti/detalji" component={StudentInfoAndGrades} />
                                <Route path="/nastavno-osoblje/predmeti/statistika" component={CourseStatistics} />


                                <Route exact path="/filtriranje-studenata" component={StudentOverviewFilter} />
                                <Route path="/filtriranje-studenata/informacije-o-studentu" component={StudentOverview} />


                            </div>
                            }

                            {activeRole.substr(0, 10) === 'Studentska' &&
                                <div>
                                    <Route path="/unos-studenta" component={StudentCreate} />
                                    <Route exact path="/spisak-studenata" component={FilterStudents} />
                                    <Route exact path="/ispis-studenata" component={Withdrawal} />
                                    <Route path="/spisak-studenata/informacije-o-studentu" component={StudentOverview} />
                                    <Route path="/upis-studenta/informacije-o-studentu" component={StudentOverview} />
                                    <Route exact path="/upis-studenata" component={StudentFilterForSPEnroll} />
                                    <Route path="/upis-studenta/studijski-programi" component={StudyPrograms} />
                                    <Route exact path="/ispitni-rokovi" component={ExamTerms} />
                                    <Route path="/ispitni-rokovi/statistika" component={ExamTermStatistics} />
                                    <Route exact path="/ispitni-rokovi/ispiti" component={Exams} />
                                    <Route path="/ispitni-rokovi/ispiti/prijave-za-ispite" component={ExamApplicationsForCurrentExam} />
                                    <Route path="/ispitni-rokovi/ispiti/detalji/studenti-iz-grupe" component={Students} />
                                    <Route path="/ispitni-rokovi/ispiti/detalji/osoblje-iz-grupe" component={Staff} />
                                    <Route path="/predmeti/kreiranje-i-prikaz-ispita-po-predmetima/detalji/studenti-iz-grupe" component={Students} />
                                    <Route path="/predmeti/kreiranje-i-prikaz-ispita-po-predmetima/detalji/osoblje-iz-grupe" component={Staff} />
                                    <Route exact path="/ispitni-rokovi/ispiti/detalji" component={EditExam} />
                                    <Route path="/ispitni-rokovi/ispiti/prijavljeni-studenti" component={RegisteredStudents} />
                                    <Route path="/ispitni-rokovi/izmjena" component={EditExamTerm} />
                                    <Route exact path="/kreiranje-i-prikaz-ispita-po-predmetima" component={CoursesList} />
                                    <Route exact path="/kreiranje-i-prikaz-ispita-po-rokovima" component={CreateExams} />
                                    {/* <Route exact path="/kreiranje-i-prikaz-ispita-po-predmetima" component={ExamDetails} /> */}
                                    <Route path="/kreiranje-i-prikaz-ispita-po-predmetima/grupe" component={ExamGroups} />
                                    <Route exact path="/kreiranje-i-prikaz-ispita-po-predmetima/detalji" component={EditExam} />
                                    <Route path="/kreiranje-i-prikaz-ispita-po-predmetima/detalji/studenti-iz-grupe" component={Students} />
                                    <Route path="/kreiranje-i-prikaz-ispita-po-predmetima/detalji/osoblje-iz-grupe" component={Staff} />
                                    <Route path="/kreiranje-i-prikaz-ispita-po-predmetima/prijavljeni-studenti" component={RegisteredStudents} />
                                    <Route exact path="/ispitne-grupe" component={TypeCourseAndImplementations} />
                                    <Route exact path="/komisijski-ispiti" component={FilterStudentsForCommitteeExam} />
                                    <Route exact path="/studenti" component={() => <FilterStudentsForCommitteeExam cancelGrade />} />
                                    <Route path="/komisijski-ispiti/poništavanje-ocjena" component={CancelGradeAndNewCommitteeExam} />
                                    <Route path="/studenti/poništavanje-ocjena" component={CancelGrade} />
                                    <Route path="/ispitne-grupe/nova-grupa" component={NewGroup} />
                                    <Route path="/ispitne-grupe/studenti" component={Students} />
                                    <Route path="/ispitne-grupe/nastavno-osoblje" component={Staff} />
                                    <Route exact path="/predmeti" component={CourseBasics} />
                                    <Route exact path="/predmeti/detalji" component={CourseDetails} />
                                    <Route exact path="/predmeti/implementacije" component={CourseImplementations} />
                                    <Route path="/predmeti/implementacije/osoblje" component={AddStaff} />
                                    <Route exact path="/studijski-programi" component={StudentServiceStudyPrograms} />
                                    <Route exact path="/studijski-programi/implementacije" component={StudentServiceSPImpl} />
                                    <Route path="/studijski-programi/implementacije/detalji" component={StudentServiceSPImplDetails} />
                                    <Route path="/studijski-programi/implementacije/semestri" component={StudentServiceSPImplSemesters} />
                                    <Route path="/prijave-za-polaganje-ispita" component={ExamApplications} />
                                    <Route path="/zahtjevi-za-dokumente" component={DocumentRequests} />
                                    <Route path="/statusne-potvrde-i-prepisi-ocjena" component={SelectStudentsForCertificate} />
                                    <Route path="/ispisnice" component={WithdrawalForm} />
                                    <Route exact path="/nastavno-osoblje" component={Employees} />
                                    <Route exact path="/korisnički-računi" component={Users} />
                                    <Route path="/nastavno-osoblje/lični-podaci" component={PersonalInfo} />
                                    <Route exact path="/nastavno-osoblje/predmeti" component={Courses} />
                                    <Route exact path="/nastavno-osoblje/mentorstva" component={Mentorships} />
                                    <Route exact path="/nastavno-osoblje/predmeti/detalji" component={CourseDetails} />
                                    <Route exact path="/nastavno-osoblje/predmeti/studenti" component={CourseStudents} />
                                    <Route path="/nastavno-osoblje/predmeti/studenti/detalji" component={StudentInfoAndGrades} />
                                    <Route path="/nastavno-osoblje/predmeti/statistika" component={CourseStatistics} />
                                    <Route path="/korisnički-računi-za-studente" component={AllStudents} />
                                    <Route path="/uvjerenje-o-završenom-ciklusu" component={Certificates} />
                                    <Route path="/konfiguracije-dokumenata" component={Configurations} />
                                    <Route exact path="/studentske-grupe" component={TypeCourseAndImplementations} />
                                    <Route path="/studentske-grupe/nova-grupa" component={NewGroup} />
                                    <Route path="/studentske-grupe/studenti" component={Students} />
                                    <Route path="/studentske-grupe/nastavno-osoblje" component={Staff} />
                                    <Route exact path="/filtriranje-studenata" component={StudentOverviewFilter} />
                                    <Route exact path="/upis-studenata/upis-na-studijski program" component={StudentSPEnroll} />
                                    <Route path="/filtriranje-studenata/informacije-o-studentu" component={StudentOverview} />
                                    <Route exact path="/ekvivalencija-ispita/komisija" component={CommitteePreview} />
                                    <Route exact path="/ekvivalencija-ispita/kreiranje-kandidata" component={CreateCandidatesTab} />
                                    <Route exact path="/ekvivalencija-ispita/prikaz-kandidata" component={CandidatesTab} />
                                    <Route path="/ekvivalencija-ispita/komisija/detalji" component={CommitteeDetails} />
                                    <Route path="/ekvivalencija-ispita/prikaz-kandidata/detalji" component={CandidateDetails} />
                                    <Route exact path="/treći-ciklus" component={ThirdCycle} />
                                    <Route path="/treći-ciklus-upis-na-predmet" component={CourseEnrollment} />
                                    <Route exact path="/prelazak-studenata" component={ExamRecognition} />
                                    <Route path="/prelazak-studenata/priznavanje-ispita" component={StudentsTab} />
                                    <Route exact path="/izvještaji" component={() => (<StudentsReports />)} />
                                    {/* <Route exact path="/izvještaji-akademsko-osoblje" component={() => (<AllReports reportSectionKey="academic staff" />)} /> */}
                                    {/* <Route exact path="/izvještaji-organizaciona-jedinica" component={() => (<AllReports reportSectionKey="organizational unit" />)} /> */}

                                    <Route exact path="/specijalistički-studij" component={PostgraduateSpecialistSP} />
                                    <Route path="/prosjeci-po-godinama" component={AverageGrade} />
                                    <Route exact path="/pitanja-i-odgovori" component={FAQAdmin} />

                                    <Route exact path="/kolizija" component={Collision} />
                                     <Route exact path="/dolazne-mobilnosti" component={ExternalStudentList} />
                                    <Route exact path="/dolazne-mobilnosti/kreiranje" component={ExternalStudentInputForm}/>
                                     <Route exact path="/dolazne-mobilnosti/student" component={ExternalStudentProfile} />
                                    <Route exact path="/dolazne-mobilnosti/registracijski-linkovi" component={RegistrationLinkList} />
                                    <Route exact path="/dolazne-mobilnosti/registracijski-linkovi/prijavljeni-studenti" component={RegistrationLinkStudentList} />

                                    <Route exact path="/neciklicni-studij" component={NonCycleStudentList}/>
                                    <Route exact path="/neciklicni-studij/student" component={NonCycleStudentProfile}/>
                                    <Route exact path="/neciklicni-studij/kreiranje" component={NonCycleStudentInputForm}/>
                                    <Route exact path="/neciklicni-studij/programi" component={NonCycleProgramList}/>
                                    <Route exact path="/neciklicni-studij/programi/detalji" component={NonCycleProgramDetails}/>

                                    <Route exact path="/administratori" component={AdminUsers}/>
                                </div>
                            }
                            {activeRole.substr(0, 19) === 'Prodekan za nastavu' &&
                            <div>
                                <Route exact path="/predmeti" component={CourseBasics} />
                                <Route exact path="/predmeti/detalji" component={CourseDetails} />
                                <Route exact path="/predmeti/implementacije" component={CourseImplementations} />
                                <Route path="/predmeti/implementacije/osoblje" component={AddStaff} />
                                <Route exact path="/studijski-programi" component={StudentServiceStudyPrograms} />
                                <Route exact path="/studijski-programi/implementacije" component={StudentServiceSPImpl} />
                                <Route path="/studijski-programi/implementacije/detalji" component={StudentServiceSPImplDetails} />
                                <Route path="/studijski-programi/implementacije/semestri" component={StudentServiceSPImplSemesters} />
                                <Route exact path="/nastavno-osoblje" component={Employees} />
                                <Route exact path="/nastavno-osoblje/predmeti" component={Courses} />
                                <Route exact path="/filtriranje-studenata" component={StudentOverviewFilter} />
                                <Route path="/filtriranje-studenata/informacije-o-studentu" component={StudentOverview} />
                                <Route exact path="/spisak-studenata" component={FilterStudents} />
                                <Route path="/spisak-studenata/informacije-o-studentu" component={StudentOverview} />
                                <Route exact path="/unsa-studenti-mobilnost" component={OutgoingMobilityStudentList} />
                                <Route exact path="/izvještaji" component={() => (<StudentsReports />)} />
                                <Route exact path="/administratori" component={AdminUsers} />
                                <Route exact path="/nastavno-osoblje/mentorstva" component={Mentorships} />
                            </div>
                            }

                            {activeRole.substr(0, 38) === 'Služba za nastavu i studentska pitanja' &&
                            <div>
                                <Route exact path="/predmeti" component={CourseBasics} />
                                <Route exact path="/predmeti/detalji" component={CourseDetails} />
                                <Route exact path="/predmeti/implementacije" component={CourseImplementations} />
                                <Route path="/predmeti/implementacije/osoblje" component={AddStaff} />
                                <Route exact path="/osnovni-studijski-programi" component={StudyProgramBasics} />
                                <Route exact path="/osnovni-studijski-programi/implementacije" component={Implementations} />
                                <Route path="/osnovni-studijski-programi/implementacije/semestri" component={Semesters} />
                                <Route path="/osnovni-studijski-programi/implementacije/izmjena-i-detalji" component={Details} />
                                <Route exact path="/ispitni-rokovi" component={ExamTerms} />
                                <Route exact path="/ispitni-rokovi/ispiti" component={Exams} />
                                <Route exact path="/ispitni-rokovi/ispiti/detalji" component={EditExam} />
                                <Route path="/ispitni-rokovi/statistika" component={ExamTermStatistics} />
                                <Route exact path="/nastavno-osoblje" component={Employees} />
                                <Route path="/nastavno-osoblje/lični-podaci" component={PersonalInfo} />
                                <Route exact path="/nastavno-osoblje/mentorstva" component={Mentorships} />
                                <Route exact path="/nastavno-osoblje/predmeti" component={Courses} />
                                <Route exact path="/nastavno-osoblje/predmeti/detalji" component={CourseDetails} />
                                <Route path="/nastavno-osoblje/predmeti/statistika" component={CourseStatistics} />
                                <Route exact path="/izvještaji" component={() => (<StudentsReports />)} />
                            </div>
                            }

                            {activeRole.substr(0, 30) === 'Služba za osiguranje kvaliteta' &&
                                <div>
                                    <Route exact path="/predmeti" component={CourseBasics} />
                                    <Route exact path="/predmeti/detalji" component={CourseDetails} />
                                    <Route exact path="/predmeti/implementacije" component={CourseImplementations} />
                                    <Route path="/predmeti/implementacije/osoblje" component={AddStaff} />
                                    <Route exact path="/osnovni-studijski-programi" component={StudyProgramBasics} />
                                    <Route exact path="/osnovni-studijski-programi/implementacije" component={Implementations} />
                                    <Route path="/osnovni-studijski-programi/implementacije/semestri" component={Semesters} />
                                    <Route path="/osnovni-studijski-programi/implementacije/izmjena-i-detalji" component={Details} />
                                    <Route exact path="/nastavno-osoblje" component={Employees} />
                                    <Route path="/nastavno-osoblje/lični-podaci" component={PersonalInfo} />
                                    <Route exact path="/nastavno-osoblje/predmeti" component={Courses} />
                                    <Route exact path="/nastavno-osoblje/predmeti/detalji" component={CourseDetails} />
                                    <Route path="/nastavno-osoblje/predmeti/statistika" component={CourseStatistics} />
                                    <Route exact path="/ispitni-rokovi" component={ExamTerms} />
                                    <Route exact path="/ispitni-rokovi/ispiti" component={Exams} />
                                    <Route exact path="/ispitni-rokovi/ispiti/detalji" component={EditExam} />
                                    <Route path="/ispitni-rokovi/statistika" component={ExamTermStatistics} />
                                    <Route exact path="/izvještaji" component={() => (<StudentsReports />)} />
                                    <Route path="/administratori" component={AdminUsers} />

                                </div>
                            }

                            {activeRole.substr(0, 40) === 'Služba za zapošljavanje Kantona Sarajevo' &&
                            <div>
                                <Route exact path="/pretraga-studenata" component={StudentFilterEmploymentServiceCS} />
                                <Route path="/pretraga-studenata/informacije-o-studentu" component={StudentInfoEmploymentServiceCS} />
                            </div>
                            }
                            {activeRole.substr(0, 30) === 'Služba za međunarodnu saradnju' &&
                            <div>
                                <Route exact path="/obavjestenja" component={AnnouncementsAdmin}/>
                                <Route exact path="/dolazne-mobilnosti" component={ExternalStudentList} />
                                <Route exact path="/odlazne-mobilnosti" component={OutgoingMobilityStudentList} />
                                <Route exact path="/dolazne-mobilnosti/student" component={ExternalStudentProfile} />
                                <Route exact path="/unsa-studenti-mobilnost" component={OutgoingMobilityStudentList} />
                                {/* <Route exact path="/dolazne-mobilnosti/kreiranje" component={ExternalStudentInputForm} /> */}
                                <Route exact path="/dolazne-mobilnosti/registracijski-linkovi" component={RegistrationLinkList} />
                                <Route exact path="/dolazne-mobilnosti/registracijski-linkovi/prijavljeni-studenti" component={RegistrationLinkStudentList} />
                                <Route path="/administratori" component={AdminUsers} />

                            </div>
                            }

                            {activeRole.startsWith('Prodekan za međunarodnu') &&
                                <div>
                                    <Route exact path="/filtriranje-studenata" component={StudentOverviewFilter} />
                                    <Route path="/filtriranje-studenata/informacije-o-studentu" component={StudentOverview} />
                                    <Route exact path="/spisak-studenata" component={FilterStudents} />
                                    <Route path="/spisak-studenata/informacije-o-studentu" component={StudentOverview} />
                                    <Route exact path="/dolazne-mobilnosti" component={ExternalStudentList} />
                                    <Route exact path="/odlazne-mobilnosti" component={() => <OutgoingMobilityStudentList hideStudentFacultyColumn />} />
                                    <Route exact path="/dolazne-mobilnosti/student" component={ExternalStudentProfile} />
                                    {/* <Route exact path="/dolazne-mobilnosti/kreiranje" component={ExternalStudentInputForm} /> */}
                                    <Route exact path="/dolazne-mobilnosti/registracijski-linkovi" component={RegistrationLinkList} />
                                    <Route exact path="/dolazne-mobilnosti/registracijski-linkovi/prijavljeni-studenti" component={RegistrationLinkStudentList} />
                                    <Route exact path="/administratori" component={AdminUsers} />
                                </div>
                            }

                            {activeRole.substr(0, 8) === 'Profesor' &&
                                <div>
                                    <FormattedMessage id="route.filterStudentsForProfessor">
                                        {(msg) => (<Route exact path={msg} component={FilterStudentsForProfessor} />)}
                                    </FormattedMessage>
                                    <FormattedMessage id="route.studentsInfoFromSearch">
                                        {(msg) => (<Route exact path={msg} component={StudentInfoAndGrades} />)}
                                    </FormattedMessage>
                                    <FormattedMessage id="route.inputGrades">
                                        {(msg) => (<Route exact path={msg} component={InputGrades} />)}
                                    </FormattedMessage>
                                    <FormattedMessage id="route.upcomingExams">
                                        {(msg) => (<Route path={msg} component={ProfessorUpcomingExams} />)}
                                    </FormattedMessage>
                                    <FormattedMessage id="route.statistic">
                                        {(msg) => (<Route path={msg} component={StatisticsForProfessor} />)}
                                    </FormattedMessage>
                                    {/* <Route exact path="/pristup-anketi" component={PollBan} /> */}
                                    <FormattedMessage id="route.access">
                                        {(msg) => (<Route path={msg} component={PollBan} />)}
                                    </FormattedMessage>
                                    {/* <Route exact path="/pristup-anketi/predmeti" component={PollBanCourseList} /> */}
                                    <FormattedMessage id="route.accessCourses">
                                        {(msg) => (<Route path={msg} component={PollBanCourseList} />)}
                                    </FormattedMessage>
                                    {/* <Route exact path="/pristup-anketi/predmeti/studenti" component={PollBanStudentList} /> */}
                                    <FormattedMessage id="route.accessStudents">
                                        {(msg) => (<Route path={msg} component={PollBanStudentList} />)}
                                    </FormattedMessage>

                                    <FormattedMessage id="route.mentorships">
                                        {(msg) => (<Route path={msg} component={Mentorships} />)}
                                    </FormattedMessage>
                                    {/* <Route exact path="/pitanja-i-odgovori" component={FAQStudentService} /> */}
                                    {/* {<Route exact path="/dolazne-mobilnosti" component={ExternalStudentList}/>} */}
                                    {<Route exact path="/dolazne-mobilnosti/student" component={ExternalStudentProfile}/>}
                                    {<Route exact path="/dolazne-mobilnosti/ocjenjivanje" component={ExternalStudentGradingList}/>}

                                    {/* <Route exact path="/neciklicni-studij" component={NonCycleStudentList}/> */}
                                    <Route exact path="/neciklicni-studij/ocjenjivanje" component={NonCycleStudentGradingList}/>
                                    <Route exact path="/neciklicni-studij/student" component={NonCycleStudentProfile}/>
                                    <Route exact path="/neciklicni-studij/programi" component={NonCycleProgramList}/>
                                    <Route exact path="/neciklicni-studij/programi/detalji" component={NonCycleProgramDetails}/>

                                </div>
                            }

                            {(activeRole.substr(0, 8) === 'Profesor' || activeRole.substr(0, 8) === 'Asistent') &&
                            <div>
                                <FormattedMessage id="route.active">
                                    {(msg) => (<Route exact path={msg} component={ActiveExams} />)}
                                </FormattedMessage>
                                <FormattedMessage id="route.finalized">
                                    {(msg) => (<Route exact path={msg} component={ProfessorHistoryGrades} />)}
                                </FormattedMessage>
                                <FormattedMessage id="route.studentGrades">
                                    {(msg) => (<Route exact path={msg} component={StudentsGrades} />)}
                                </FormattedMessage>
                                <FormattedMessage id="route.examStatistic">
                                    {(msg) => (<Route path={msg} component={ExamStatistic} />)}
                                </FormattedMessage>
                                <FormattedMessage id="route.registeredStudents">
                                    {(msg) => (<Route path={msg} component={RegisteredStudents} />)}
                                </FormattedMessage>
                                <FormattedMessage id="route.personalInf">
                                    {(msg) => (<Route path={msg} component={PersonalInfo} />)}
                                </FormattedMessage>
                                <FormattedMessage id="route.courses">
                                    {(msg) => (<Route exact path={msg} component={Courses} />)}
                                </FormattedMessage>
                                <FormattedMessage id="route.courseDetails">
                                    {(msg) => (<Route exact path={msg} component={CourseDetails} />)}
                                </FormattedMessage>
                                <FormattedMessage id="route.courseStudents">
                                    {(msg) => (<Route exact path={msg} component={CourseStudents} />)}
                                </FormattedMessage>
                                <FormattedMessage id="route.courseStatistic">
                                    {(msg) => (<Route path={msg} component={CourseStatistics} />)}
                                </FormattedMessage>
                                <FormattedMessage id="route.studentsInfo">
                                    {(msg) => (<Route path={msg} component={StudentInfoAndGrades} />)}
                                </FormattedMessage>
                                <FormattedMessage id="route.studentGradesAndInfo">
                                    {(msg) => (<Route exact path={msg} component={StudentInfoAndGrades} />)}
                                </FormattedMessage>
                                <FormattedMessage id="route.studentGradesAndInfoFromFinalised">
                                    {(msg) => (<Route exact path={msg} component={StudentInfoAndGrades} />)}
                                </FormattedMessage>

                                {/* <Route exact path="/ankete" component={PollListProfessors} /> */}
                                <FormattedMessage id="route.polls">
                                    {(msg) => (<Route exact path={msg} component={PollListProfessors} />)}
                                </FormattedMessage>

                                {/* <Route exact path="/ankete/predmeti" component={CourseListProfessors} /> */}
                                <FormattedMessage id="route.pollCourses">
                                    {(msg) => (<Route exact path={msg} component={CourseListProfessors} />)}
                                </FormattedMessage>
                                {/* <Route exact path="/ankete/predmeti/rezultati" component={CourseResultsOverview} /> */}
                                <FormattedMessage id="route.pollResults">
                                    {(msg) => (<Route exact path={msg} component={CourseResultsOverview} />)}
                                </FormattedMessage>
                                <FormattedMessage id="route.faq">
                                    {(msg) => (<Route path={msg} component={FAQStudentService} />)}
                                </FormattedMessage>
                            </div>
                            }

                            {activeRole.substr(0, 8) === 'Asistent' && <FormattedMessage id="route.upcomingExams">
                                {(msg) => (<Route path={msg} component={ProfessorUpcomingExams} />)}
                            </FormattedMessage>}

                            {activeRole.substr(0, 8) === 'Asistent' && <FormattedMessage id="route.filterStudentsForProfessor">
                                {(msg) => (<Route exact path={msg} component={FilterStudentsForProfessor} />)}
                            </FormattedMessage>}

                            {activeRole.substr(0, 8) === 'Asistent' && <FormattedMessage id="route.studentsInfoFromSearch">
                                {(msg) => (<Route exact path={msg} component={StudentInfoAndGrades} />)}
                            </FormattedMessage>}

                            {activeRole.substr(0, 12) === 'Ministarstvo' &&
                                <div>
                                </div>
                            }

                            {(activeRole.substr(0, 8) === 'Student:' || activeRole.substr(0, 11) === 'Diplomirani' || activeRole.substr(0, 7) === 'Ispisan') &&
                                <div>

                                    <FormattedMessage id="route.personalInfo">
                                        {(msg) => (<Route path={msg} component={StudentPersonalInfo} />)}
                                    </FormattedMessage>
                                    <FormattedMessage id="route.collisionCourses">
                                        {(msg) => (<Route path={msg} component={CollisionCourses} />)}
                                    </FormattedMessage>
                                    <FormattedMessage id="route.optionalCourses">
                                        {(msg) => (<Route path={msg} component={OptionalCourses} />)}
                                    </FormattedMessage>
                                    <FormattedMessage id="route.currentSemesterCourses">
                                        {(msg) => (<Route path={msg} component={CurrentSemesterCourses} />)}
                                    </FormattedMessage>
                                    <FormattedMessage id="route.gradesOverview">
                                        {(msg) => (<Route path={msg} component={StudentPassedExams} />)}
                                    </FormattedMessage>
                                    <FormattedMessage id="route.coursesOverview">
                                        {(msg) => (<Route path={msg} component={StudentCoursesOverview} />)}
                                    </FormattedMessage>
                                    <FormattedMessage id="route.passedExams">
                                        {(msg) => (<Route path={msg} component={StudentPassedExams} />)}
                                    </FormattedMessage>
                                    <FormattedMessage id="route.requests">
                                        {(msg) => (<Route path={msg} component={StudentsCertificateRequests} />)}
                                    </FormattedMessage>
                                    <FormattedMessage id="route.registeredExams">
                                        {(msg) => (<Route path={msg} component={StudentRegisteredExams} />)}
                                    </FormattedMessage>
                                    <FormattedMessage id="route.academicStaff">
                                        {(msg) => (<Route path={msg} component={Employees} />)}
                                    </FormattedMessage>
                                    <FormattedMessage id="route.faq">
                                        {(msg) => (<Route path={msg} component={FAQStudentService} />)}
                                    </FormattedMessage>


                                </div>
                            }
                            {activeRole.substr(0, 8) === 'Student:' &&
                                <div>

                                    <FormattedMessage id="route.registerExams">
                                        {(msg) => (<Route path={msg} component={StudentRegisterExams} />)}
                                    </FormattedMessage>
                                    {/* <Route exact path="/stipendije" component={Scholarship} /> */}
                                    <Route exact path="/ankete" component={PollList} />
                                    <Route exact path="/anketa/predmeti" component={PollCourseListPreview} />
                                    <Route exact path="/anketa/predmeti/ocjenjivanje" component={CoursePollPreview} />
                                    <Route exact path="/anketa/" component={() => <Redirect push to={{ pathname: '/ankete' }} />} />
                                    <Route exact path="/anketa-sp/:pollName" component={StudentPollPreview} />
                                </div>
                            }

                            {activeRole.substr(0, 14) === 'QA admin - OJ:' &&
                            <div>
                                <Route exact path="/ankete" component={PollListQA} />
                                <Route exact path="/ankete/osoblje" component={StaffTabs} />
                                <Route exact path="/ankete/osoblje/predmeti" component={CourseList} />
                                <Route exact path="/ankete/osoblje/predmeti/rezultati" component={CourseResultsOverview} />
                                <Route exact path="/ankete/sp" component={SspList} />
                                <Route exact path="/ankete/sp/rezultati" component={CourseResultsOverview} />
                                <Route exact path="/ankete/struktura-uzorka" component={StaffPollStructureReport} />
                                {/*<Route exact path="/izvještaji-ankete" component={PollReport} />*/}
                                {/*<Route exact path="/izvještaji-ankete/predmeti" component={StaffPollCourseReport} />*/}
                                {/*<Route exact path="/izvještaji-ankete/nastavno-osoblje" component={StaffPollStaffReport} />*/}
                                {/*<Route exact path="/izvještaji-ankete/opće-informacije" component={SspPollGeneralInformationReport} />*/}
                                {/*<Route exact path="/izvještaji-ankete/organizacija-studija" component={SspPollStudyProgramOrganizationReport} />*/}
                                {/*<Route exact path="/izvještaji-ankete/nastavni-program" component={SspPollSyllabusReport} />*/}
                                {/*<Route exact path="/izvještaji-ankete/rad-službi" component={SspPollServicesReport} />*/}
                                {/* <Route exact path="/ankete/osoblje/predmeti/grafički-prikaz" component={StatisticDashboard} /> */}
                                <Route exact path="/pitanja-i-odgovori" component={FAQStudentService} />
                                <Route path="/administratori" component={AdminUsers} />

                            </div>
                            }

                            {activeRole.startsWith('QA admin:') &&
                                <div>
                                    <Route exact path="/ankete" component={PollTab} />
                                    <Route exact path="/ankete/kreiranje" component={CreateNewPoll} />
                                    <Route path="/ankete/detalji" component={PollPreviewTabs} />
                                    <Route path="/ankete/uredi" component={PollEdit} />
                                    <Route exact path="/rezultati" component={PollListQA} />
                                    <Route exact path="/rezultati/struktura-uzorka" component={StaffPollStructureReport} />
                                    <Route exact path="/rezultati/osoblje" component={StaffTabs} />
                                    <Route exact path="/rezultati/osoblje/predmeti" component={CourseList} />
                                    <Route exact path="/rezultati/osoblje/predmeti/pregled" component={CourseResultsOverview} />
                                    <Route exact path="/rezultati/sp" component={SspList} />
                                    <Route exact path="/rezultati/sp/pregled" component={CourseResultsOverview} />

                                    <Route exact path="/pitanja-i-odgovori" component={FAQStudentService} />
                                    <Route path="/administratori" component={AdminUsers} />

                                </div>
                            }

                            {(activeRole.substr(0, 13) === 'Administrator' || activeRole.substr(0, 7) === 'Imovina') &&
                                <div>
                                    <Route exact path="/imovina/nepokretna-imovina" component={Property} />
                                    <Route exact path="/imovina/nepokretna-imovina/kreiranje" component={CreateProperty} />
                                    <Route exact path="/imovina/nepokretna-imovina/detalji" component={PropertyDetails} />
                                    <Route path="/imovina/sredstva" component={Resources} />
                                    <Route path="/imovina/prostorije" component={Rooms} />
                                    <Route path="/imovina/prostorije/test" component={Premises} />
                                    <Route path="/imovina/zakupi" component={Leases} />
                                    <Route path="/imovina/zakupci" component={Leaseholder} />
                                    <Route path="/imovina/vozila" component={Vehicles} />
                                    {activeRole.substr(0, 7) === 'Imovina' &&
                                        <Route exact path="/administratori" component={AdminUsers} />
                                    }
                                </div>
                            }

                            {activeRole.substr(0, 12) === 'Ministarstvo' &&
                                <div>
                                </div>
                            }

                            {activeRole.substr(0, 2) === 'HR' &&
                                <div>
                                    <Route exact path="/nenastavno-osoblje" component={EmployeeListNonAcademic} />
                                    <Route exact path="/nastavno-i-naučno-istraživačko-osoblje" component={EmployeeListAcademic} />
                                    <Route exact path="/angažovano-osoblje" component={EmployeeListAssociate} />
                                    <Route path="/nenastavno-osoblje/informacije-o-zaposleniku" component={Profile} />
                                    <Route path="/nastavno-i-naučno-istraživačko-osoblje/informacije-o-zaposleniku" component={Profile} />
                                    <Route path="/angažovano-osoblje/informacije-o-zaposleniku" component={Profile} />
                                    <Route path="/dodavanje-opterećenja" component={Workload} />
                                    <Route exact path="/pretraga-i-unos-osobe" component={CheckPersonAndEmployee} />
                                    <Route path="/pretraga-i-unos-osobe/informacije-o-zaposleniku" component={Profile} />
                                    <Route path="/pretraga-i-unos-osobe/dodavanje-osobe" component={AddNewPerson} />
                                    <Route path="/pretraga-i-unos-osobe/dodavanje-zaposlenika" component={AddNewEmployee} />
                                    {/* <Route path="/lista-zaposlenika/informacije-o-zaposleniku" component={AddNewEmployee} /> */}
                                    <Route exact path="/sistematizacije" component={Systematization} />
                                    <Route exact path="/lista-za-zaposljavanje" component={EmploymentList} />
                                    <Route path="/sistematizacije/pozicije" component={PositionsForSystematization} />
                                    <Route exact path="/izvještaji" component={Reports} />
                                    <Route exact path="/pitanja-i-odgovori" component={FAQStudentService} />
                                    <Route exact path="/administratori" component={AdminUsers} />
                                </div>
                            }


                            <Route exact path="/u/:id" component={() => <Dashboard activeRole={this.state.activeRole} />} />
                            <Route exact path="/" component={() => <Dashboard activeRole={this.state.activeRole} />} />
                            <Route exact path="/obavijesti" component={() => <Notifications />} />
                            <FormattedMessage id="route.comments">
                                {(msg) => (<Route path={msg} component={MailForm} />)}
                            </FormattedMessage>
                            <FormattedMessage id="route.contact">
                                {(msg) => (<Route path={msg} component={Contact} />)}
                            </FormattedMessage>
                            <Route path="/404" component={NotFound} />

                        </div>

                    </main>
                    <Aside />
                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Full);



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js